import React from 'react'

const API_BASE = (process.env.REACT_APP_API_BASEURL || '').replace(/\/api\/?$/, '')

const getGameImageUrl = (item: any) => {
  const url = item?.game_images || item?.image_url || item?.game_image
  return url && typeof url === 'string' && url.trim() !== '' ? url.trim() : ''
}

const resolveImage = (item: any, overrideImages?: Record<string, string>, useCustomImage?: Record<string, boolean>) => {
  const gid = item?.game_identifier || item?.identifier || item?._id
  if (gid && overrideImages?.[gid] && useCustomImage?.[gid]) {
    const override = overrideImages[gid]
    return override.startsWith('http') ? override : `${API_BASE}${override}`
  }
  return getGameImageUrl(item)
}

const CasinoListItemInt = (props: any) => {
  const overrideImages = props.overrideImages
  const useCustomImage = props.useCustomImage
  return (
    <>
      {props.games &&
        props.games.map((Item: any, key: number) => {
          const imgUrl = resolveImage(Item, overrideImages, useCustomImage)
          return (
            <div className={"casino-list-item"} onClick={(e) => { e.preventDefault(); props.setGamePlay(Item) }} key={key} title={`${Item.game_name} - lotusbookio`}>
              <a href='#' className='' >
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: imgUrl ? `url(${imgUrl})` : undefined,
                    backgroundColor: imgUrl ? undefined : '#2d3748',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {!imgUrl && (
                    <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.7)', textAlign: 'center' }}>No image</span>
                  )}
                </div>
              </a>
            </div>
          )
        })}
    </>
  )
}
export default React.memo(CasinoListItemInt)
